exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading[data-v-13c9ecbf]{margin-top:1rem;font-size:16px;font-weight:700;margin-bottom:.25rem;border-bottom:1px solid var(--light)}.heading+.group[data-v-13c9ecbf]{padding:.5rem 0}.heading+.group p[data-v-13c9ecbf]{margin:0}.heading+.group[data-v-13c9ecbf]>:first-child{margin-top:0}.heading+.group[data-v-13c9ecbf]>:last-child{margin-bottom:0}", ""]);

// exports
